function buildLetterPdfOptions(orientation, extraOptions = {}) {
  return {
    ...extraOptions,
    orientation,
    unit: 'mm',
    format: 'letter',
  }
}

function createLetterPdf(orientation, jsPDF, extraOptions = {}) {
  return new jsPDF(buildLetterPdfOptions(orientation, extraOptions))
}

export { buildLetterPdfOptions, createLetterPdf }
